<template>
  <div class="home">
    <el-row>
      <el-col :span="24" class="main">
        <div class="home-top">
          <div class="logo">梦想新能充电平台</div>
          <div class="home-top-right">
            <div class="user-message">
              <div class="user-name" @mouseenter="enter()" @mouseleave="leave()">
                <span>{{ name }}</span><i :class="[actives==true?'actives':'']"></i>
              </div>
              <ul @mouseenter="enter()" @mouseleave="leave()" :class="[active==true?'active':'']">
                <li @click="personalCenterClick()">个人中心</li>
              </ul>
            </div>
            <div class="login-out" @click="loginOutClick()"><i></i>退出</div>
          </div>
        </div>
      </el-col>
      
    </el-row>
    <div class="box-bottom">
      <sidebar @event="formChild"></sidebar>
      <div style="clear:both;"></div>
      <div class="route" :class="[routeT==true?'route-64':'route-200']">
        <transition>
          <router-view v-bind:routeT="routeT"></router-view>
        </transition>
      </div>
      <div style="clear:both;"></div>
    </div>
  </div>
</template>

<script>
import sidebar from "./sidebar";
export default {
  data() {
    return {
      active:false,
      name:"",
      actives:false,
      routeT:true,
    };
  },
  mounted() {
   
  },
  created() {
    try {
      if(localStorage.getItem("uname") == "null"){
        this.name = localStorage.getItem("uname");
      } else {
        this.name = localStorage.getItem("nickname");
      }
      
    } catch(e) {}
  },
  methods: {
    formChild(data){
      // console.log("home " + data);
      this.routeT = data;
    },
    loginOut(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/logout",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
            if(su.data.code == 1){
              localStorage.clear(); 
              this.$router.push({ path: "/login" });
              localStorage.setItem('routerName', "homePage");
            } else if(su.data.code == 300){
              this.$router.push({ path: "/login" });
              // this.$message.error(su.data.message);
            } else if(su.data.code == 301){
              this.$message.error(su.data.message);
            } else if (su.data.code == 900)  {
            } else{
              this.$message.error(su.data.message);
            }
          })
        .catch(err => {
          this.$message.error(err.data.message);
        });
    },
    loginOutClick(){
      this.$confirm('确定退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loginOut();
        }).catch(() => {      
        });
    },
    enter(){
      this.active = true;
      this.actives = true;
    },
    leave(){
      this.active = false;
      this.actives = false;
    },
    personalCenterClick(){
      this.$router.push({ path: "/personalCenter" });
    },
  },
  components: { sidebar }
};
</script>

<style scoped lang="scss">
.home {
  position: relative;
  .home-top {
    width: 100%;
    height: 60px;
    background-color: #13151b;
    // display: flex;
    // align-items: center;
    position: fixed;
    // top:0;
    // left: 0;
    z-index: 99;
    display: flex;
    justify-content:space-between;
    .logo {
      width: 290px;
      height: 36px;
      margin-left: -30px;
      margin-top: 12px;
      color:#fff;
      font-size: 23px;
      //background: url(../assets/img/logo.png) no-repeat;
    }
    .home-top-right {
      position: absolute;
      right:0;
      // width: 14%;
      .user-message {
        width: auto;
        height: 60px;
        float: left;
        margin-right:36px;
        .user-name {
          line-height: 60px;
          padding:0 12px;
          cursor: pointer;
          span {
            color: #fff;
          }
          i {
            display: inline-block;
            width: 12px;
            height: 8px;
            background: url(../assets/img/icon.png) -232px -64px no-repeat;
            margin-left:10px;
          }
          i.actives {
            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: rotate(180deg);
            -webkit-transition: .3s ;
            -o-transition: .3s ;
            transition: .3s ;
          }
        }
        ul {
          position: relative;
          z-index: 999;
          background-color: #13151b;
          color: #fffffd;
          line-height: 45px;
          display: none;
          list-style: none;
          li {
            cursor: pointer;
            padding:0 12px;
          }
        }
        ul.active {
          display: block;
        }
      }
      .login-out {
        width: 80px;
        height: 60px;
        color:#fff;
        cursor: pointer;
        line-height: 60px;
        float: right;
        display: flex;
        align-items: center;
        font-size: 14px;
        i {
          display: inline-block;
          width: 13px;
          height: 13px;
          background: url(../assets/img/icon.png) -231px -32px no-repeat;
          margin-right: 10px;
        }
      }
    }
  }
  .box-bottom {
    width: 100%;
    height: auto;
    display: flex;
    .body-left {
      width:auto;
    }
    .route {
      flex: 1;
      position: absolute;
      right: 0;
      top:0;
      left: 0;
      bottom:0;
    }
    .route-200 {
      margin-left: 150px;
      -webkit-transition: .3s ;
      -o-transition: .3s ;
      transition: .3s ;
    }
    .route-64 {
      margin-left: 48px;
      -webkit-transition: .3s ;
      -o-transition: .3s ;
      transition: .3s ;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue